import React from "react";

export const FeatureUnavailable: React.FC = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center min-vh-100">
      <h1 className="mb-3">Feature Unavailable</h1>
      <p className="text-muted">
        This Feature is not available in your region.
      </p>
    </div>
  );
};
